import { Directive } from '@angular/core';

@Directive({
  selector: '[appEmptyContainer]'
})
export class EmptyContainerDirective {}
